import React from 'react';
import { getBezierPath, EdgeProps, BaseEdge } from 'reactflow';

const EventConnectionEdge = ({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data, markerEnd }: EdgeProps) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          strokeDasharray: '6 4',
          stroke: '#e74c3c',
          strokeWidth: 2,
        }}
      />
      {data?.label && (
        <text>
          <textPath href={`#${id}`} style={{ fontSize: 10, fill: '#e74c3c' }} startOffset="50%" textAnchor="middle">
            {data.label}
          </textPath>
        </text>
      )}
    </>
  );
};

export default EventConnectionEdge;
